<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box no-display">
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-toolbar flat class="toolbar" dense justify="center">
        <v-toolbar-title align="center">
          <strong> Attendance Summary Report </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row class="no-display" dense justify="center">
        <v-col cols="12" sm="3" md="3">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            required
            color="#0F2027"
            v-model="org"
            :items="org_list"
            item-text="name"
            return-object
            label="Organization"
            outlined
            @click="clear()"
            @change="getAy()"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            required
            color="#0F2027"
            v-model="ay"
            :items="academic_year_list"
            item-text="ay"
            return-object
            label="Academic Year"
            @click="clear()"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            required
            color="#0F2027"
            v-model="stream_id"
            :items="stream_list"
            item-text="str"
            return-object
            label="Stream"
            @click="clear()"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col sm="2" v-if="div_list != null">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete color="#0F2027" multiple dense rounded required v-model="div" item-value="id" :items="div_list" item-text="division" label="Division" outlined />
              </v-col>
        <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list" item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
        <v-col cols="12" sm="3" md="3">
          <!-- <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-left="65"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="error">*</v-icon
              ><v-text-field
                dense
                rounded
                outlined
                @blur="date = parseDate(date)"
                hint="YYYY/MM/DD format"
                persistent-hint
                v-model="date"
                label="Select Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu> -->
          
                  <v-icon color="error">*</v-icon>
                  From Date :
                  <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="date" />
              </v-col>
              <v-col cols="12" sm="3" md="3">
                  <v-icon color="error">*</v-icon>
                  To Date :
                  <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="to_date" />
              </v-col>
      
        <v-col cols="12" sm="2" md="2" v-if="ay && org && stream_id && date">
          <v-btn
            class="mt-6 button"
            :loading="fetch_loader"
            @click="getreport()"
            >Fetch / Generate</v-btn
          >
        </v-col>
      </v-row>
      <!-- <span v-if="mainList != '' && mainList != null" class="no-display">
        <v-data-table
          v-if="mainList.length > 0"
          :headers="headers1"
          :items="mainList"
          :search="search"
          dense
          class="elevation-1 mytable"
          item-key="ld_id"
        >
        </v-data-table>
      </span>
      <br />
    </v-card>
    <v-btn
      v-if="mainList != '' && mainList != null"
      class="ma-2 no-display"
      tile
      outlined
      color="warning"
      @click="print()"
    >
      <v-icon left>mdi-printer</v-icon> Print Report<v-icon right></v-icon>
    </v-btn> -->
    <!-- <v-simple-table v-if="mainList != '' && mainList != null" dense>
      <template v-slot:default>
        <thead>
          <tr>
            <td v-if="org_basic_data.trust_logo">
              <center>
                <img
                  :src="org_basic_data.trust_logo"
                  width="40%"
                  height="50%"
                  alt="logo"
                />
              </center>
            </td>
            <td colspan="7">
              <center>
                <tr v-if="org_basic_data.trust_name">
                  <strong>{{ org_basic_data.trust_name }}</strong>
                </tr>
                <tr v-if="org_basic_data.school_name">
                  <strong>{{ org_basic_data.school_name }}</strong>
                </tr>
                <tr>
                  <b>Stream : </b>
                  {{
                    stream_id.str
                  }}
                   </tr>
                <tr>
                  <b>Group : </b>
                  All
                </tr>
                <tr>
                  <b>Batch : </b>
                  {{
                    ay.ay
                  }}
                </tr>
                <tr>
                  <b>Date : </b>
                  {{
                    new_date
                  }}
                </tr>
                <br />
                <tr>
                  <b>Attendance Summary Report</b>
                </tr>
              </center>
            </td>
            <td v-if="org_basic_data.school_logo">
              <center>
                <img
                  :src="org_basic_data.school_logo"
                  width="40%"
                  height="50%"
                  alt="logo"
                />
              </center>
            </td>
          </tr>
          <tr>
            <td class="text">Sr. No.</td>
            <td class="text">Class &amp; Division</td>
            <td class="text">Total Strength</td>
            <td class="text">Boys Present</td>
            <td class="text">Boys Absent</td>
            <td class="text">Girls Present</td>
            <td class="text">Girls Absent</td>
            <td class="text">Total Absent</td>
            <td class="text">Total Present</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in mainList" :key="item.name">
            <td>{{ item.srno }}</td>
            <td>{{ item.class_division }}</td>
            <td>{{ item.total_strength }}</td>
            <td>{{ item.boys_present }}</td>
            <td>{{ item.boys_absent }}</td>
            <td>{{ item.girls_present }}</td>
            <td>{{ item.girls_absent }}</td>
            <td>{{ item.total_absent }}</td>
            <td>{{ item.total_present }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table> -->
    <v-simple-table v-for="item,index in mainList" :key="index" v-if="mainList != '' && mainList != null" dense :items-per-page="-1" id="my-table-id">
          <template v-slot:default>
              <thead>
                  <tr>
                      <td colspan="1" v-if="org_basic_data.trust_logo">
                          <center>
                              <img :src="org_basic_data.trust_logo" width="40%" height="50%" alt="logo" />
                          </center>
                      </td>
                      <td colspan="7">
                          <center>
                              <div v-if="org_basic_data.trust_name">
                                  <strong>{{ org_basic_data.trust_name }}</strong>
                              </div>
                              <div v-if="org_basic_data.school_name">
                                  <strong>{{ org_basic_data.school_name }}</strong>
                              </div>
                              <div>
                                  <b>Stream : </b>
                                  {{
                    stream_id.str
                  }}
                                  <b>Group : </b>
                                  All
                              </div>
                              <div>
                                  <b>Batch : </b>
                                  {{
                    ay.ay
                  }}
                              </div>
                              <div>
                                  <b>Date : </b>
                                  {{ index }}
                              </div>
                              <br />
                              <div>
                                  <b>Attendance Summary Report</b>
                              </div>
                          </center>
                      </td>
                      <td colspan="1" v-if="org_basic_data.school_logo">
                          <center>
                              <img :src="org_basic_data.school_logo" width="40%" height="50%" alt="logo" />
                          </center>
                      </td>
                  </tr>
                  <tr>
                      <td class="text">Sr. No.</td>
                      <td class="text">Class &amp; Division</td>
                      <td class="text">Total Strength</td>
                      <td class="text">Boys Present</td>
                      <td class="text">Boys Absent</td>
                      <td class="text">Girls Present</td>
                      <td class="text">Girls Absent</td>
                      <td class="text">Total Absent</td>
                      <td class="text">Total Present</td>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="item in item" :key="item.name">
                      <td>{{ item.srno }}</td>
                      <td>{{ item.class_division }}</td>
                      <td>{{ item.total_strength }}</td>
                      <td>{{ item.boys_present }}</td>
                      <td>{{ item.boys_absent }}</td>
                      <td>{{ item.girls_present }}</td>
                      <td>{{ item.girls_absent }}</td>
                      <td>{{ item.total_absent }}</td>
                      <td>{{ item.total_present }}</td>
                  </tr>
              </tbody>
          </template>
      </v-simple-table>
      </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import LearnetMarksheetOfAdmin from "../../Examination/Admin/LearnetMarksheetOfAdmin";
export default {
  components: {
    "learner-marksheet-admin": LearnetMarksheetOfAdmin,
  },
  data() {
    return {
      modal: false,
      modal2: false,
      modal3: false,
      menu2: false,
      menu3: false,
      menu11: false,
      loader: false,
      overlay: false,
      color: "",
      snackbar: false,
      search: null,
      snackbar_msg: null,
      current_academic_year: null,
      stream: null,
      header: null,
      standard_list: null,
      dision_list: null,
      org_list: null,
      display_data: false,
      org_data_list: [],
      division_list: [],
      dialog: false,
      org_data: [],
      div_list: null,
      div: null,
      fetch_loader: false,
      header_list: [],
      org: null,
      show: false,
      std_id: null,
      stream_id: null,
      stream_list: [],
      ay: null,
      academic_year_list: null,
      date: null,
      mainList: null,
      new_date: null,
      org_basic_data: [],
      to_date:null,
      status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
              ],
              status: null,
      headers1: [
        {
          text: "Sr. No.",
          value: "srno",
        },
        {
          text: "Class & Division",
          align: "center",
          value: "class_division",
        },
        {
          text: "Total Strength",
          align: "center",
          value: "total_strength",
        },
        {
          text: "No. of Boys Present",
          align: "center",
          value: "boys_present",
        },
        {
          text: "No. of Girls Present",
          align: "center",
          value: "girls_present",
        },
        {
          text: "No. of Boys Absent",
          align: "center",
          value: "boys_absent",
        },
        {
          text: "No. of Girls Absent",
          align: "center",
          value: "girls_absent",
        },
        {
          text: "Total Absent",
          align: "center",
          value: "total_absent",
        },
        {
          text: "Total Present",
          align: "center",
          value: "total_present",
        },
      ],
    };
  },
  watch: {},
  methods: {
    convert(date) {
      var datearray = date.split("-");
      var newdate = datearray[2] + "/" + datearray[1] + "/" + datearray[0];
      return newdate;
    },
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    getreport() {
      this.fetch_loader = true;
      const formData = {
        org: this.org.id,
        ay: this.ay.ay_id,
        stream: this.stream_id.str_id,
        date: this.date,
        status: this.status,
        to_date:this.to_date,
        division:this.div
      };
      axios
        .post("/Academics/getAttendanceSummaryReport", formData)
        .then((res) => {
          if (res.data.final_list.length != 0) {
            this.mainList = res.data.final_list;
            this.org_basic_data = res.data.org_basic_data;
            this.fetch_loader = false;
            this.new_date = this.convert(this.date);
          } else {
            this.showSnackbar("#b71c1c", "No data found!"); // show snackbar
            this.mainList = null;
            this.fetch_loader = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.fetch_loader = false;
        })
        .finally(() => {
          ay = null;
          this.fetch_loader = false;
        });
    },
    clear() {
      this.org_data_list = [];
    },
    getAy() {
      this.academic_year_list = null,
      this.standard_list = null,
      this.ay = null
      this.std_id = null,
      this.stream_list = null
      this.stream_id = [],
      this.div = null
      this.div_list = null
      const data = {
        org: this.org.id,
      };
      axios
        .post("/Management/getAy", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.academic_year_list = res.data.academic_year_list;
            this.stream_list = res.data.stream_list;
            this.div_list = res.data.div_list
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {
          //close loader
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/Management/getOrg_without_all")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_list = res.data.org_list;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {
          //close loader
        });
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  img {
    width: 100% !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  @page {
    margin-top: none;
    padding-top: none;
    size: 15.5in 15.5in;
  }
  thead {
    text-align: center !important;
    margin: none;
    padding: 1rem !important;
    font-size: xx-large !important;
    font-weight: bold !important;
    border-bottom: 1px solid black;
    border: 1px solid black;
  }
}
</style>
